export default {
      id: "icon--customer-service-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--customer-service-usage",
      toString: function () {
        return this.url;
      }
    }